import UserList from '../../../base/pages/userlist';

const userList: UserList = {
  header: 'Benutzerliste',
  remove: 'Löschen'
};

export default userList;
